var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.54083 11.7559C2.99588 7.52833 7.1377 4.5 12 4.5C16.8623 4.5 21.0041 7.52833 22.4592 11.7559C22.5136 11.9141 22.5136 12.0859 22.4592 12.2441C21.0041 16.4717 16.8623 19.5 12 19.5C7.1377 19.5 2.99588 16.4717 1.54083 12.2441C1.48639 12.0859 1.48639 11.9141 1.54083 11.7559ZM3.04727 12C4.3631 15.4826 7.85943 18 12 18C16.1406 18 19.6369 15.4826 20.9527 12C19.6369 8.51743 16.1406 6 12 6C7.85943 6 4.3631 8.51743 3.04727 12Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9ZM7.5 12C7.5 9.51472 9.51472 7.5 12 7.5C14.4853 7.5 16.5 9.51472 16.5 12C16.5 14.4853 14.4853 16.5 12 16.5C9.51472 16.5 7.5 14.4853 7.5 12Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.447251c529448aef6de25b9d0b51f41c.svg";
export { ForwardRef as ReactComponent };